module.exports = `${require.publicPath}about-img02.c2d3cb46.png`;